// @ts-expect-error Library not migrated yet
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const RSS_STATUS_MAP_TRANSLATION_KEYS = {
  FOUND_RSS_FEEDS: 'EmailComponentsCrossFrame.rssUrl.status.found_rss_feeds',
  NO_FEEDS_FOUND: 'EmailComponentsCrossFrame.rssUrl.status.no_feeds_found',
  INVALID_URL: 'EmailComponentsCrossFrame.rssUrl.status.invalid_url',
  VALIDATOR_ERROR: 'EmailComponentsCrossFrame.rssUrl.status.validator_error',
  HTTP_RETRIEVAL_ERROR: 'EmailComponentsCrossFrame.rssUrl.status.http_retrieval_error',
  NO_GUID_OR_LINK: 'EmailComponentsCrossFrame.rssUrl.status.no_guid_or_link_jsx',
  NO_GENERATED_GUID: 'EmailComponentsCrossFrame.rssUrl.status.no_generated_guid_jsx',
  FEED_EMPTY: 'EmailComponentsCrossFrame.rssUrl.status.feed_empty',
  FEED_OK: 'EmailComponentsCrossFrame.rssUrl.status.feed_ok',
  TIMEOUT: 'EmailComponentsCrossFrame.rssUrl.status.timeout',
  LOADING: 'EmailComponentsCrossFrame.rssUrl.status.loading',
  REQUIRED: 'EmailComponentsCrossFrame.rssUrl.status.required'
};
const JSX_STATUS_MESSAGE = ['NO_GUID_OR_LINK', 'NO_GENERATED_GUID'];
const RssStatusMessage = ({
  status
}) => {
  if (JSX_STATUS_MESSAGE.includes(status)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: RSS_STATUS_MAP_TRANSLATION_KEYS[status],
      elements: {
        KnowledgeBaseButton
      },
      options: {
        url: 'https://knowledge.hubspot.com/articles/kcs_article/email/why-didnt-my-rss-email-send'
      }
    });
  } else return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: RSS_STATUS_MAP_TRANSLATION_KEYS[status]
  });
};
export default RssStatusMessage;